<div class="notification-alert" [ngClass]="{ active: isAlertNotification }">
  @for (messages of messagesListAlert; track messages.userId) {
    <div
      class="message"
      [ngClass]="{ hidden: messages.hidden }"
      [routerLink]="messages.link">
      <div class="message_header">
        <div class="message_header_left">
          <img
            src="./assets/svg/logo_notifications.svg"
            alt="Logo Notifications" />
          <div class="message_header_tile">
            <p class="desc_text">
              {{ 'TYPE' | translate }}:
              <span class="desc_">{{ messages.processType }}</span>
            </p>
            <p class="desc_text">
              {{ 'PROCESS' | translate }}:
              <span class="desc_text">{{ messages.notificationType }}</span>
            </p>
          </div>
        </div>
        <div class="message_header_data">
          <p>{{ messages.createdAt | date: 'hh:mm' }}</p>
        </div>
      </div>
      <div class="message_description">
        <p class="desc_message">{{ messages.body }}</p>
        <button class="message_view" [routerLink]="messages.link">View</button>
      </div>
    </div>
  }
</div>
